import { supabase } from "@/lib/supabaseClient";
import type {
  PendingEmployeeFieldVerificationRow,
  VerifyPendingEmployeeFieldValueInput,
  VerifyPendingEmployeeFieldValueResult,
} from "./mappers";
import { assertOk, type RpcResult } from "./mappers";

function normalizePendingEmployeeFieldVerificationRow(
  row: any
): PendingEmployeeFieldVerificationRow {
  return {
    pending_value_id: String(row.pending_value_id),
    company_id: String(row.company_id),
    employee_id: row.employee_id == null ? null : String(row.employee_id),
    employee_display_name:
      row.employee_display_name == null ? null : String(row.employee_display_name),
    employee_number: row.employee_number == null ? null : String(row.employee_number),
    field_key: String(row.field_key),
    field_label: row.field_label == null ? String(row.field_key) : String(row.field_label),
    field_category: row.field_category == null ? null : String(row.field_category),
    submitted_value: row.submitted_value,
    submitted_by: row.submitted_by == null ? null : String(row.submitted_by),
    submitted_by_email:
      row.submitted_by_email == null ? null : String(row.submitted_by_email),
    submitted_at: String(row.submitted_at),
    required_authority:
      row.required_authority == null ? null : String(row.required_authority),
    import_batch_id: row.import_batch_id == null ? null : String(row.import_batch_id),
    import_row_id: row.import_row_id == null ? null : String(row.import_row_id),
    import_row_number:
      row.import_row_number == null ? null : Number(row.import_row_number),
    original_filename:
      row.original_filename == null ? null : String(row.original_filename),
    diagnostic_payload: row.diagnostic_payload ?? null,
  };
}

export async function listPendingEmployeeFieldVerifications(
  companyId: string
): Promise<PendingEmployeeFieldVerificationRow[]> {
  const res = (await supabase.rpc("list_pending_employee_field_verifications", {
    p_company_id: companyId,
  })) as RpcResult<any[]>;

  return assertOk(res).map(normalizePendingEmployeeFieldVerificationRow);
}

export async function verifyPendingEmployeeFieldValue(
  input: VerifyPendingEmployeeFieldValueInput
): Promise<VerifyPendingEmployeeFieldValueResult> {
  const res = (await supabase.rpc("verify_pending_employee_field_value", {
    p_pending_value_id: input.pendingValueId,
    p_approve: input.approve,
    p_rejection_reason: input.rejectionReason ?? null,
  })) as RpcResult<VerifyPendingEmployeeFieldValueResult>;

  return assertOk(res);
}

export async function verifyPendingEmployeeFieldValues(input: {
  pendingValueIds: string[];
  approve: boolean;
  rejectionReason?: string | null;
}): Promise<VerifyPendingEmployeeFieldValueResult> {
  const res = (await supabase.rpc("verify_pending_employee_field_values", {
    p_pending_value_ids: input.pendingValueIds,
    p_approve: input.approve,
    p_rejection_reason: input.rejectionReason ?? null,
  })) as RpcResult<VerifyPendingEmployeeFieldValueResult>;

  return assertOk(res);
}